import brsearch from "./brsearch";
import pdsearch from "./pdsearch";
import cnsearch from "./cnsearch";
import atsearch from "./atsearch";
import glsearch from "./glsearch"
import statesearch from "./statesearch"
import districtsearch from "./districtsearch"
import talukasearch from "./talukasearch"
import areasearch from "./areasearch"
import villagesearch from "./villagesearch"
import custgroupsearch from "./custgroupsearch"
import maritalstatusearch from "./maritalstatusearch"
import occupationsearch from "./occupationsearch"
import castsearch from "./castsearch"
import proofaddsearch from "./proofaddsearch";
import proofidentitysearch from "./proofidentitysearch";
import religionsearch from "./religionsearch";
import incomegroupsearch from "./incomegroupsearch"
import divisionsearch from "./divisionsearch";
import subdivisionsearch from "./subdivisionsearch"
import reasonsearch from "./reasonsearch";
import titlesearch from "./titlesearch";
import ledgergroupsearch from "./ledgergroupsearch";
import regionsearch from "./regionsearch"
import jointtypesearch from "./jointtypesearch";
import relcodesearch from "./relcodesearch";
import securitysearch from "./securitysearch"
import vehicletypesearch from "./vehicletypesearch";
import sanctionbysearch from "./sanctionbysearch";
import referencedbysearch from "./referencedbysearch";
import purposesearch from "./purposesearch";
import prioritysectorsearch from "./prioritysectorsearch";
import prioritysegmentsearch from "./prioritysegmentsearch";
import categorysearch from "./categorysearch";
import industrytypesearch from "./industrytypesearch";
import healthsearch from "./healthsearch";
import cibilaccounttypesearch from "./cibilaccounttypesearch";
import societysearch from "./societysearch";
import refdirectorsearch from "./refdirectorsearch";
import goldcodesearch from "./goldcodesearch";
import membernosearch from "./membernosearch";
import showsamenamesearch from "./showsamenamesearch";
import accounttypesearch from "./accounttypesearch";
import modeofopsearch from "./modeofopsearch";
import producttypesearch from "./producttypesearch";
import loanactionsearch from "./loanactionsearch"
import npastatussearch from "./npastatussearch";
import groupsearch from "./groupsearch";
import bankcodesearch from "./bankcodesearch";
import authorisedsignsearch from "./authorisedsignsearch";
import ifsccodesearch from "./ifsccodesearch";


export default { brsearch ,pdsearch,cnsearch,atsearch,glsearch,statesearch,districtsearch,talukasearch,areasearch,villagesearch,custgroupsearch,maritalstatusearch,occupationsearch,castsearch,proofaddsearch,proofidentitysearch,religionsearch,incomegroupsearch,divisionsearch,subdivisionsearch,reasonsearch,titlesearch,ledgergroupsearch,regionsearch,jointtypesearch,relcodesearch,securitysearch,vehicletypesearch,sanctionbysearch,referencedbysearch,purposesearch,prioritysectorsearch,prioritysegmentsearch,categorysearch,industrytypesearch,healthsearch,cibilaccounttypesearch,societysearch,refdirectorsearch,goldcodesearch,membernosearch,showsamenamesearch,accounttypesearch,modeofopsearch,producttypesearch,npastatussearch,loanactionsearch,groupsearch,bankcodesearch,authorisedsignsearch,ifsccodesearch};